import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import { AuthContextProvider } from "./Context/AuthContext";
import './i18n/i18n';

// Attach Authorization header with accessToken for all requests
axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {}
  return config;
});

// Handle token expiration - redirect to login on 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or unauthorized
      // Clear all auth data
      try {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('accessTokenExpiresAtUtc');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('role');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('accessTokenExpiresAtUtc');
        sessionStorage.removeItem('userDetails');
        sessionStorage.removeItem('role');
      } catch (_) {
        // ignore storage errors
      }
      // Redirect to login page
      // Don't redirect if already on login page to avoid redirect loops
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
  <AuthContextProvider>
    <App />
  </AuthContextProvider>
  </>
);
